module.exports = __webpack_public_path__ + "static/img/twitter-bird-only-red.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/twitter-bird-only-red.svg
// module id = 417
// module chunks = 0